export default "__VITE_ASSET__Xq$vO$RT__"